export default __webpack_public_path__ + "static/media/image-fnda2-550x510.64727802.jpg";